<!--
 * @Descripttion: logisticsOrderList--物流订单表
 * @version: 1
 * @Author: lk
 * @Date: 2019-08-19 17:14:03
 * @LastEditors: lzq
 * @LastEditTime: 2024-01-11 10:27:47
 -->
<template>
  <div v-loading.fullscreen="loading" element-loading-text="加载中">
    <el-card>
      <condition-search :query-items="queryItems" :search-param="searchParam" @search="search" @reset="reset" />
    </el-card>
    <el-card>
      <el-button v-if="$btnsPermission('warehouse:add')" type="primary" @click="handleAdd">新增仓库</el-button>
      <el-table style="margin-top: 12px;" ref="dataTable" :height="heightStyleObj" :data="pageListData" align="center" border>
        <el-table-column prop="" width="60" label="序号" show-overflow-tooltip>
          <template slot-scope="{ $index }">
            {{ $index + 1 + (searchParam.pageNum - 1) * searchParam.pageSize }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="name" min-width="120px" label="仓库名称"></el-table-column>
        <el-table-column show-overflow-tooltip prop="code" width="120px" label="仓库编码" />
        <el-table-column show-overflow-tooltip prop="address" min-width="120px" label="仓库地址">
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="chargeUserName" width="120px" label="仓库负责人">
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="chargeUserTel" width="120px" label="负责人电话">
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="createBy" min-width="120px" label="创建人"></el-table-column>
        <el-table-column show-overflow-tooltip width="160px" label="创建时间">
          <template slot-scope="scope">
            {{ scope.row.createTime ? parseTime(scope.row.createTime) : null }}
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="180" align="center">
          <template slot-scope="{ row }">
            <el-button v-if="$btnsPermission('warehouse:edit')" type="text" @click="handleEdit(row)">
              编辑
            </el-button>
            <el-button v-if="$btnsPermission('warehouse:del')" type="text" @click="hanldDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="searchParam.total > 0" :total="searchParam.total" :page.sync="searchParam.pageNum"
        :limit.sync="searchParam.pageSize" @pagination="getPageListData" />
    </el-card>
    <addOrEdit v-if="addShow" :visible="addShow" :warehouse-info="warehouseInfo" @close="closeAdd"></addOrEdit>
  </div>
</template>

<script>
import { deleteWarehouse, getWareHouseStock } from '@/api/warehouse'
import addOrEdit from './components/addOrEdit'
export default {
  components: {
    addOrEdit,
  },
  data() {
    return {

      heightStyleObj: '',
      loading: true, // 遮罩
      addShow: false, // 新增仓库
      pageListData: [], // 列表数据
      queryItems: [
        {
          label: '关键字',
          field: 'searchValue',
          placeholder: '仓库名称/仓库编码',
          width: '300px',
          type: 'input'
        },
        {
          label: '创建时间',
          field: 'dateTime',
          type: 'date',
        },
      ],
      dictObj: [],
      searchParam: { // 查询参数
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
    }
  },


  created() {
    this.heightStyleObj = window.innerHeight - 405 + 'px'
    this.getPageListData()
  },
  methods: {
    handleAdd() {
      this.warehouseInfo = {}
      this.addShow = true
    },
    handleEdit(row) {
      // if(row.stock) return this.$message.error('当前仓库已存在产品，无法修改')
      this.addShow = true
      this.warehouseInfo = JSON.parse(JSON.stringify(row))
    },
    // 关闭新增弹窗
    closeAdd() {
      this.addShow = false;
      this.getPageListData()
    },
    //删除仓库
    hanldDelete({ id,stock }) {
      if(stock) return this.$message.error('当前仓库已存在产品，无法删除')
      this.$confirm('您确定要删除当前仓库？', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true // 打开遮罩
        deleteWarehouse(id).then(() => {
          this.$message.success('删除成功')
          this.getPageListData() // 重新加载数据列表
        }).finally(() => {
          this.loading = false // 关闭遮罩
        })
      })

    },

    // 查询
    search() {
      this.searchParam.pageNum = 1
      this.getPageListData()
    },
    // 重置查询
    reset() {
      this.searchParam = Object.assign(this.$data.searchParam, this.$options.data.call(this)).searchParam
      this.getPageListData()
    },

    // 获取列表数据
    getPageListData() {
      this.loading = true
      const searchParam = JSON.parse(JSON.stringify(this.searchParam))
      if (searchParam.dateTime) {
        const [startDate, endDate] = searchParam.dateTime
        searchParam.startDate = startDate
        searchParam.endDate = endDate
        delete searchParam.dateTime
      }
      getWareHouseStock(searchParam).then(res => {
        this.searchParam.total = res.total
        this.pageListData = res.rows
      }).finally(() => {
        this.loading = false
      })
    },
  }
}
</script>
